import AdminDatePicker from "routes/admin/datePicker/AdminDatePicker";
import style from "./ProductInquirySearch.module.css";
import VerticalFlex from "layouts/flex/VerticalFlex";
import FlexChild from "layouts/flex/FlexChild";
import HorizontalFlex from "layouts/flex/HorizontalFlex";
import Center from "layouts/wrapper/Center";
import P from "components/P";
import CustomButton from "components/buttons/CustomButton";
import {
  forwardRef,
  useContext,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { BrowserDetectContext } from "providers/BrowserEventProvider";
import { useTranslation } from "react-i18next";
import InputText from "components/inputs/InputText";
import AdminDateChoice from "routes/admin/datePicker/AdminDateChoice";
import CheckBox from "components/inputs/checkBox/CheckBox";
import CheckBoxRow from "components/inputs/checkBox/CheckBoxRow";
import CheckCircle from "components/inputs/checkBox/CheckCircle";
import { Radio, RadioGroup } from "@mui/material";
import NiceModal from "@ebay/nice-modal-react";
import clsx from "classnames";
import { requester, adminRequester } from "App";
import { useNavigate } from "react-router-dom";

const ProductInquirySearch = forwardRef((props, ref) => {
  const { reset, setReset, research } = props;
  const [reload, setReload] = useState(false);
  // const newDay = new Date();
  // const dateRef = useRef();
  const inputRef = useRef();
  // const navigate = useNavigate();
  // newDay.setDate(today.getDate() - 7);
  // const [active, setActive] = useState([false, false, false, false, false]);

  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState(null);
  const [isMounted, setIsmounted] = useState(false);

  const [
    selectedProductDisplayValue,
    setSelectedProductDisplayValue,
  ] = useState("all");
  const [selectedRestockStatus, setSelectedRestockStatus] = useState("all");
  const [selectedSearchType, setSelectedSearchType] = useState("product");
  const [selectedProductType, setSelectedProductType] = useState("all");
  const [searchCategory, setSearchCategory] = useState([]);
  const [max, setMax] = useState(0);
  const onProductTypeChange = (e) => {
    setSelectedProductType(e.target.value);
  };
  const onProductDisplayValueChange = (e) => {
    setSelectedProductDisplayValue(e.target.value);
  };
  const onRestockStatusValueChange = (e) => {
    setSelectedRestockStatus(e.target.value);
  };
  const categoryToId = (categories, withChild = false) => {
    if (withChild) {
      return categories
        ?.map((category) => [
          category.id,
          ...categoryToId(category?.category_children, true),
        ])
        .flat();
    } else {
      return categories?.map((category) => category.id);
    }
  };

  useEffect(() => {
    // requester.getAllCategoriesForAdmin((result) => {
    //   setCategories(result.data);
    // });
    adminRequester.getCategories(
      {
        expand: "parent_category,category_children",
        include_descendants_tree: true,
        parent_category_id: "null",
      },
      (result) => {
        setCategories(result.product_categories);
        const ids = categoryToId(result.product_categories, true) || [];
        setMax(ids?.length);
        setSearchCategory([]);
      }
    );
    setIsmounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      //   requester.getProductStatistics((result) => {
      //     setProductsStatus(result.data);
      //   });
      inputRef.current.focus();
    }
  }, [isMounted]);

  // const datePickerClick = (active) => {
  //     setActive(active);
  // }

  //   const onCategorySearchClick = () => {
  //     NiceModal.show("checkSelect", {
  //       list: categories,
  //       title: "카테고리 목록",
  //       theader: categorySelectHeader,
  //       justifyContent: "flex-start",
  //       onSelect: onCategorySelect,
  //     });
  //   };
  //   const onCategorySelect = (categories) => {

  //     setSelectedCategories(categories);
  //   };

  const onSearchClick = () => {
    if (props.callback) {
      const data = {
        search: selectedSearchType,
        input: inputRef.current.getValue(),
        type: selectedProductType,
        display: selectedProductDisplayValue,
        stock: selectedRestockStatus,
        status: "table",
      };
      if (selectedCategories) data.categories = selectedCategories;
      props.callback(data);
    }
  };

  const onInitializationClick = () => {
    inputRef.current.setValue("");
    setSelectedSearchType("product");
    // setActive([false, false, false, false, false]);
    const ids = categoryToId(categories, true) || [];
    setMax(ids?.length);
    setSelectedCategories(null);
    setSearchCategory([]);
    setSelectedRestockStatus("all");
    setSelectedProductType("all");
    setSelectedProductDisplayValue("all");
    const interval = setInterval(() => {
      setReload(true);
      clearInterval(interval);
    }, 100);
  };

  const searchStyle = {
    backgroundColor: "var(--admin-main-color)",
    padding: "7px 20px",
    border: "1px solid #ddd",
  };
  const initializationStyle = {
    backgroundColor: "white",
    padding: "7px 20px",
    color: "black",
    border: "1px solid #ddd",
  };

  useEffect(() => {
    setIsmounted(true);
  }, []);
  useEffect(() => {
    if (isMounted) {
      inputRef.current.focus();
      onInitializationClick();
    }
  }, [isMounted]);
  useEffect(() => {
    if (reset) {
      onInitializationClick();
      setReset(false);
    }
  }, [reset]);
  useEffect(() => {
    if (research) onSearchClick();
  }, [research]);
  useEffect(() => {
    if (reload) {
      setReload(false);
      onSearchClick();
    }
  }, [reload]);
  return (
    <div className={style.container}>
      <VerticalFlex>
        <FlexChild>
          <VerticalFlex>
            <FlexChild>
              <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        검색분류
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild width={300}>
                  <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                    <FlexChild width={"initial"}>
                      <select
                        value={selectedSearchType}
                        className={style.categorySelect}
                        onChange={(e) => setSelectedSearchType(e.target.value)}
                      >
                        <option value="product">상품명</option>
                        <option value="variant">옵션명</option>
                        <option value="product_id">상품코드</option>
                        <option value="variant_id">옵션코드</option>
                      </select>
                    </FlexChild>
                    <InputText
                      ref={inputRef}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") onSearchClick();
                      }}
                    />
                  </HorizontalFlex>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10}>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        상품구분
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild>
                  <RadioGroup
                    value={selectedProductType}
                    onChange={onProductTypeChange}
                  >
                    <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                      <FlexChild width={"max-content"}>
                        <Radio name="productType" value="all" />
                        <P size={15} color={"#aaa"}>
                          전체
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="productType" value="basic" />
                        <P size={15} color={"#aaa"}>
                          기본상품
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="productType" value="set" />
                        <P size={15} color={"#aaa"}>
                          세트상품
                        </P>
                      </FlexChild>
                    </HorizontalFlex>
                  </RadioGroup>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex gap={10}>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        상품분류
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild>
                  <HorizontalFlex gap={10} justifyContent={"flex-start"}>
                    <FlexChild width={"initial"}>
                      <div
                        className={clsx(style.categoryWrap, {
                          [style.selected]: selectedCategories === null,
                        })}
                        onClick={() => setSelectedCategories(null)}
                      >
                        <Center width={"100%"} textAlign={"left"}>
                          <P>전체분류</P>
                        </Center>
                      </div>
                    </FlexChild>
                    <FlexChild width={"initial"}>
                      <div
                        className={`${style.categoryWrap} ${
                          selectedCategories && selectedCategories?.length === 0
                            ? style.selected
                            : null
                        }`}
                        onClick={() => setSelectedCategories([])}
                      >
                        <Center width={"100%"} textAlign={"left"}>
                          <P>미분류</P>
                        </Center>
                      </div>
                    </FlexChild>
                    <FlexChild width={"initial"}>
                      <select
                        value={
                          searchCategory?.length === 0
                            ? -1
                            : searchCategory?.[0]?.id
                        }
                        placeholder="대분류"
                        className={`${style.categorySelect} ${
                          selectedCategories?.length === 1 &&
                          searchCategory.length === 1
                            ? style.selected
                            : null
                        }`}
                        onChange={(e) => {
                          const searchCategory = categories.filter(
                            (category) => category.id === e.target.value
                          )?.[0];
                          setSearchCategory([searchCategory]);
                          setSelectedCategories([searchCategory.id]);
                        }}
                      >
                        <option value={-1} disabled>
                          대분류
                        </option>
                        {categories?.map((category) => (
                          <option key={category?.name} value={category?.id}>
                            {category.name}
                          </option>
                        ))}
                      </select>
                    </FlexChild>
                    <FlexChild width={"initial"}>
                      <select
                        value={
                          searchCategory?.length < 2
                            ? -1
                            : searchCategory?.[1]?.id
                        }
                        className={`${style.categorySelect} ${
                          selectedCategories?.length === 1 &&
                          searchCategory.length === 2
                            ? style.selected
                            : null
                        }`}
                        onChange={(e) => {
                          if (searchCategory?.length === 0) return;

                          searchCategory[1] = searchCategory[0]?.category_children?.filter(
                            (category) => category.id === e.target.value
                          )?.[0];
                          setSearchCategory([
                            searchCategory[0],
                            searchCategory[1],
                          ]);
                          setSelectedCategories([searchCategory[1].id]);
                        }}
                      >
                        <option value={-1} disabled>
                          중분류
                        </option>
                        {searchCategory?.length > 0 &&
                          searchCategory?.[0]?.category_children?.map(
                            (category) => (
                              <option key={category?.name} value={category?.id}>
                                {category.name}
                              </option>
                            )
                          )}
                      </select>
                    </FlexChild>
                    <FlexChild width={"initial"}>
                      <select
                        value={
                          searchCategory?.length < 3
                            ? -1
                            : searchCategory?.[2]?.id
                        }
                        className={`${style.categorySelect} ${
                          selectedCategories?.length === 1 &&
                          searchCategory.length === 3
                            ? style.selected
                            : null
                        }`}
                        onChange={(e) => {
                          if (searchCategory?.length < 2) return;

                          searchCategory[2] = searchCategory[1]?.category_children?.filter(
                            (category) => category.id === e.target.value
                          )?.[0];
                          setSearchCategory([...searchCategory]);
                          setSelectedCategories([searchCategory[2].id]);
                        }}
                      >
                        <option value={-1} disabled>
                          소분류
                        </option>
                        {searchCategory?.length > 1 &&
                          searchCategory?.[1]?.category_children?.map(
                            (category) => (
                              <option key={category?.name} value={category?.id}>
                                {category.name}
                              </option>
                            )
                          )}
                      </select>
                    </FlexChild>
                  </HorizontalFlex>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>

            <FlexChild>
              <HorizontalFlex>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        진열상태
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild>
                  <RadioGroup
                    value={selectedProductDisplayValue}
                    onChange={onProductDisplayValueChange}
                  >
                    <HorizontalFlex gap={30}>
                      <FlexChild width={"max-content"}>
                        <Radio name="productDisplay" value="all" />
                        <P size={15} color={"#aaa"}>
                          전체
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="productDisplay" value={"display"} />
                        <P size={15} color={"#aaa"}>
                          진열
                        </P>
                      </FlexChild>
                      <FlexChild>
                        <Radio name="productDisplay" value={"nonDisplay"} />
                        <P size={15} color={"#aaa"}>
                          미진열
                        </P>
                      </FlexChild>
                    </HorizontalFlex>
                  </RadioGroup>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
            <FlexChild>
              <HorizontalFlex>
                <FlexChild
                  width={"10%"}
                  backgroundColor={"var(--admin-table-bg-color)"}
                >
                  <div className={style.titleWrap}>
                    <Center>
                      <P size={15} weight={"bold"}>
                        재고상태
                      </P>
                    </Center>
                  </div>
                </FlexChild>
                <FlexChild>
                  <RadioGroup
                    value={selectedRestockStatus}
                    onChange={onRestockStatusValueChange}
                  >
                    <HorizontalFlex gap={30}>
                      <FlexChild width={"max-content"}>
                        <Radio name="restockStatus" value="all" />
                        <P size={15} color={"#aaa"}>
                          전체
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="restockStatus" value="soldOut" />
                        <P size={15} color={"#aaa"}>
                          품절
                        </P>
                      </FlexChild>
                      <FlexChild width={"max-content"}>
                        <Radio name="restockStatus" value="almostSoldOut" />
                        <P size={15} color={"#aaa"}>
                          품절임박
                        </P>
                      </FlexChild>
                      <FlexChild>
                        <Radio name="restockStatus" value="inStock" />
                        <P size={15} color={"#aaa"}>
                          재고여유
                        </P>
                      </FlexChild>
                    </HorizontalFlex>
                  </RadioGroup>
                </FlexChild>
              </HorizontalFlex>
            </FlexChild>
          </VerticalFlex>
        </FlexChild>
        <FlexChild backgroundColor={"#f5f6fb"} padding={"15px 0"}>
          <HorizontalFlex gap={20}>
            <FlexChild justifyContent={"flex-end"}>
              <CustomButton
                text={"조건검색"}
                style={searchStyle}
                onClick={onSearchClick}
              />
            </FlexChild>
            {/* <FlexChild width={"max-content"}>
              <CustomButton
                text={"상품 등록"}
                style={searchStyle}
                onClick={onProductRegisterClick}
              />
            </FlexChild> */}
            <FlexChild>
              <CustomButton
                text={"초기화"}
                style={initializationStyle}
                onClick={() => setReset(true)}
              />
            </FlexChild>
          </HorizontalFlex>
        </FlexChild>
      </VerticalFlex>
    </div>
  );
});

export default ProductInquirySearch;
